import DOMPurify from 'dompurify';

const SAFE_URI_PATTERN = /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i;

const domPurifyConfig: DOMPurify.Config = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: [
    'script',
    'iframe',
    'object',
    'embed',
    'applet',
    'form',
    'input',
    'button',
    'textarea',
    'select',
    'option',
    'meta',
    'link',
    'base'
  ],
  ALLOWED_URI_REGEXP: SAFE_URI_PATTERN
};

export const sanitizeCmsHtml = (rawHtml: string): string => {
  if (!rawHtml) return '';

  return DOMPurify.sanitize(rawHtml, domPurifyConfig);
};
